import {useIsRtl} from 'store/Store'
import {useState} from 'services/hooks'
// import {useGetDancesQuery} from 'store/slices/api/danceApi'

const isFlex = {
    true: 'flex',
    false: 'none',
}

const UsePageHeader = () => {
    const isRtl = useIsRtl()

    const [anchorEl, setAnchorEl] = useState(false)
    const [languageAnchorEl, setLanguageAnchorEl] = useState(null)
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null)
    const [mobileSearchAnchorEl, setMobileSearchAnchorEl] = useState(null)
    const [mobileSideAnchorEl, setMobileSideAnchorEl] = useState(null)

    const isMobileSearchMenuOpen = Boolean(mobileSearchAnchorEl)
    const isMobileSideMenuOpen = Boolean(mobileSideAnchorEl)

    const handleMobileSideMenuClose = () => {
        setMobileSideAnchorEl(null)
    }
    const handleMobileSideMenuOpen = (event) => {
        setMobileSideAnchorEl(event.currentTarget)
    }
    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleLanguageMenuOpen = (event) => {
        setLanguageAnchorEl(event.currentTarget)
    }

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget)
    }

    const handleMobileSearchMenuOpen = (event) => {
        setMobileSearchAnchorEl(event.currentTarget)
    }

    const handleMobileSearchMenuClose = () => {
        setMobileSearchAnchorEl(null)
    }

    const menuId = 'primary-search-account-menu'
    const languageMenuId = 'primary-search-account-menu-language'
    const mobileMenuId = 'primary-search-account-menu-mobile'
    const mobileSideMenuId = 'primary-search-account-side-menu-mobile'
    return {
        dances: [],
        menuId,
        languageMenuId,
        mobileMenuId,
        mobileSideMenuId,
        handleMobileSideMenuOpen,
        isFlex,
        isMobileSearchMenuOpen,
        isMobileSideMenuOpen,
        handleMobileSearchMenuOpen,
        isLoading: false,
        handleLanguageMenuOpen,
        handleProfileMenuOpen,
        isRtl,
        handleMobileMenuOpen,
        anchorEl,
        setAnchorEl,
        setMobileMoreAnchorEl,
        mobileMoreAnchorEl,
        mobileSearchAnchorEl,
        handleMobileSearchMenuClose,
        mobileSideAnchorEl,
        handleMobileSideMenuClose,
        languageAnchorEl,
        setLanguageAnchorEl,
    }
}

export default UsePageHeader
